/*
  Author: Andrés Aguilar
  email: andresyoshimar@gmail.com
  date: 13/06/2019
  version: 0.0.1
  build: 13/06/2019
 */
<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <!-- <md-icon>perm_identity</md-icon> -->
      <div class="card-icon">
        <img-with-fallback
          :src="account.avatar"
          alt="User picture"
        />
      </div>
      <h3 class="title ">
        {{ `${account.treatment} ${account.firstName} ${account.lastName} ${account.secondLastName}` }}
        ({{ account.username }})
      </h3>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-100">
          <md-field>
            <p class="title title-large"> Contacto </p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-50">
          <md-field>
            <p> <span>Email: </span> {{ account.email }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-50">
          <md-field>
            <p> <span>Email alternativo: </span> {{ account.alternativeEmail }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Teléfono</span> {{ account.phone }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Extensión</span> {{ account.phoneExt }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Cellphone</span> {{ account.cellphone }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-100">
          <md-field>
            <p class="title title-large">Dirección</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Calle: </span> {{ account.address.street }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Colonia: </span> {{ account.address.colony }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <md-field>
            <p> <span>Municipio: </span> {{account.address.municipality ? account.address.municipality.name : 'N/A' }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <p> <span>Estado: </span> {{ account.address.state ? account.address.state.name : 'N/A'}}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <p> <span>C.P.: </span> {{ account.address.postal_code }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <p> <span>Número: </span> {{ account.address.no_ext }}</p>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <p> <span>Número interior: </span> {{ account.address.no_int }}</p>
          </md-field>
        </div>
      </div>
    </md-card-content>
    <slot name="footer">
    </slot>
  </md-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserCard",
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(["account"])
  }
};
</script>
<style lang="css" scoped>
img {
  max-width: 60px;
}
span {
  color: #606060;
}
.title-large {
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfileComponents/UserCard.vue